import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext } from 'react';
interface ToroExtensionContext {
  isToroExtension: boolean;
}
const ToroExtensionContext = createContext<ToroExtensionContext>({
  isToroExtension: false
});
export function ToroExtensionContextWrapper(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      isToroExtension: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ToroExtensionContext.Provider value={t1}>{children}</ToroExtensionContext.Provider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function useIsToroExtension() {
  return useContext(ToroExtensionContext).isToroExtension;
}